import { t } from '@lingui/macro';

export const GenericException = 'Generic.GenericException';

export interface ErrorCodes {
  [key: string]: string;
}

export const errorCodesDictionary = (): ErrorCodes => ({
  // correlations
  'Correlations.CustomPath.InvalidTotalPipeLength': t`Total length is invalid`,
  'Have not tried retrieving graph data': t`Have not tried retrieving graph data`,
  // account
  'Account.AccountNameNotUnique': t`Account name is not unique`,
  'Account.AccountCannotDeleteAssociatedSitesExist': t`Account cannot be deleted due to containing associated sites`,
  'Account.AccountCannotDeleteOwnedSitesExist': t`Account cannot be deleted due to containing owned sites`,
  'Account.AccountCannotDeleteChildAccountExist': t`Account cannot be deleted due to containing child account`,
  'Account.AccountNotFound': t`Account not found`,
  'Account.AccountIsTopLevel': t`Account is top level`,
  'Account.AccountLinkedHierarchyNotExists': t`There is no link between parent accounts of given accounts`,
  'Account.AccountParentIncorrect': t`Account has incorrect parent`,
  // csv
  'Csv file has sites that you are not allowed to use': t`Csv file has sites that you are not allowed to use`,
  'Csv file has invalid format': t`Csv file has invalid format`,
  // credits
  'Credits.CreditSettingKeyNotSet': t`Credit setting key is not set`,
  'Credits.CannotFindTopLevelAccount': t`Cannot find top-level account for given account`,
  'Credits.CannotFindCreditTypeIdForKey': t`Cannot find credit type ID for the given credit setting key`,
  'Credits.CannotFindCreditIdForCreditTypeIdAndAccount': t`Cannot find credit ID for the given credit type ID and account`,
  'ErrorCode.Credit.CreditNotFound': t`Cannot find credit`,
  'ErrorCode.Credit.NotEnoughCredits': t`Not enough credits available`,
  // survey
  'Survey.DeviceInfoIncomplete': t`Survey device information is incomplete`,
  'Survey.PipeInfoIncomplete': t`Survey pipe information is incomplete`,
  'Survey.NodeIdsNotFound': t`Cannot find node IDs for the given survey`,
  'Survey.ProblemWithRecordingDetails': t`Survey recording details are incomplete`,
  'Survey.MapNotFound': t`Survey map not found`,
});
